import script from "./UINavbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UINavbar.vue?vue&type=script&lang=ts&setup=true"

import "./UINavbar.vue?vue&type=style&index=0&id=1a0e56da&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0e56da"]])

export default __exports__